import { ICertificateQuery } from '../interfaces/certificate.query.interface';

export class Certificate {
    static label_singular = 'certificate';
    static label_plural = 'certificates';

    static props_to_search = ['name'];

    id: string;
    name: string;
    certificateName: string;
    isPublic: boolean;
    modules?: string[];
    filename: string;

    constructor(query?: ICertificateQuery) {
        if (query) {
            this.id = query.id ? query.id.toString() : null;
            this.name = query.certificate_name;
            this.certificateName = query.certificate_name;
            this.isPublic = query.is_public;
            this.filename = query.filename;

            if (query.used_by) {
                this.modules = query.used_by.modules.map(({ name }) => name);
            }
        } else {
            this.id = null;
            this.name = '';
            this.certificateName = '';
            this.filename = '';
            this.isPublic = null;
        }
    }
}
